"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const popoverContentStyles = ({
  variant
}) => ({
  padding: 4,
  marginBottom: 0,
  maxWidth: '20rem',
  borderRadius: 'base',
  background: variant === 'dark' ? 'secondary.default' : 'white',
  boxShadow: '2px 2px 4px 0 rgba(0,45,91,0.1)',
  color: variant === 'dark' ? 'white' : 'black',
  borderColor: 'gray.100',
  borderWidth: '1px',
  borderStyle: 'solid',
  '--popper-arrow-shadow-color': t => t.colors.gray['100'],
  zIndex: 'layer10',
  _focusVisible: {
    outline: '3px solid rgba(91, 170, 250, 0.7)'
  }
});
var _default = exports.default = popoverContentStyles;